import styled from 'styled-components';

export const editIconStyle = {
  fontSize: 13,
};

export const removeIconStyle = {
  fontSize: 18,
};

export const NoteContent = styled.div`
  display: flex;
  align-content: center;
  justify-content: space-between;
  margin-bottom: 3px;
`;

export const NoteWrapper = styled.div`
  font-size: 13px;
  margin-top: 7px;

  p {
    margin: 2px;
  }
`;

export const NoteLabel = styled.span`
  font-weight: 600;
  text-transform: uppercase;
`;

export const ButtonsWrapper = styled.span`
  display: flex;
  align-items: flex-start;
`;
